import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { ApprovalStatus } from 'modules/contracts/lib/enums'
import { Compensations } from 'modules/contracts/store/collections/compensations'

export interface AdditionalCompensationsContractData {
  loading: boolean
  additionalCompensations: Compensations
}

const useFetchCompensationsWithContractStatus = (
  contractVersionIds: number[] | undefined,
  contractApprovalStatus: ApprovalStatus[] | undefined
): AdditionalCompensationsContractData => {
  const additionalCompensations = useLazyRef(() => new Compensations()).current
  const { loading } = useAsyncData(async () => {
    const promises = []
    if (contractVersionIds)
      promises.push(
        additionalCompensations.fetchWithContractApprovalStatusByContractIds(
          contractVersionIds,
          contractApprovalStatus
        )
      )
    return Promise.all(promises)
  }, [contractVersionIds?.join()])

  return {
    loading,
    additionalCompensations,
  }
}

export default useFetchCompensationsWithContractStatus
